






















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Product } from "@/controller/my-routine-products";
import CategoryChip from "./CategoryChip.vue";
import TableEditButton from "@/components/TableEditButton.vue";
import TableDeleteButton from "@/components/TableDeleteButton.vue";

@Component({
  components: {
    CategoryChip,
    TableEditButton,
    TableDeleteButton
  }
})
export default class ProductTable extends Vue {
  @Prop({ type: Array, required: true })
  products!: Product[];

  emitEdit(event: Event, product: Product) {
    this.$emit("edit", product);
  }

  emitDelete(event: Event, product: Product) {
    this.$emit("delete", product);
  }
}
